
export const baseApiUrl = 'https://dentalplus.intelite.com.br/api/'
//export const baseApiUrl = 'http://localhost:3002/api/'
export const userKey = '__orale_user'
export const operadora = {
    nome: "Dental Plus",
    nomeMaiusculo: "DENTAL PLUS",
    corPrincipal: "#1DAFFC",
    corSecundaria: "#ffffff",
    numeroAns: 314366,
    usaCupomDesconto: true,
    usaPagamentoMensalBoleto: true,
    usaPagamentoMensalCartao: true,
    // Pagamento anual desativado em 15/09/2026 a pedido do comercial: clientes estavam
    // contratando anual sem intenção (propostas 6970461470 e 6983261036). O campo
    // `pagamentoAnual` do plano não controla nada — o gate real é aqui.
    usaPagamentoAnualBoleto: false,
    usaPagamentoAnualCartao: false,
    usaPagamentoAnualParceladoCartao: false,
}

export const modelBoleto = {
    pagadorDocumentoTipo: 1,
    pagadorDocumentoNumero: '',
    pagadorNome: '',
    pagadorEndereco: '',
    pagadorBairro: '',
    pagadorCidade: '',
    pagadorUf: '',
    pagadorCep: '',
    dataVencimento: '',
    valorNominal: 0,
    multaPercentual: 0,
    multaQuantidadeDias: 0,
    jurosPercentual: 0,
    tipoDesconto: 0,
    descontoValor: 0,
    descontoDataLimite: '',
    valorAbatimento: 0,
    tipoProtesto: 0,
    protestoQuantidadeDias: 0,
    baixaQuantidadeDias: 0,
    mensagem: '',
    tipoTitulo: 4,
    nsu: '',
    nossoNumero: 0,
    seuNumero: '',
    convenioId: '2c9bff05-3e9c-4d22-ae52-fcfdcddd6fb4'
}

export default { baseApiUrl, modelBoleto, operadora }